export enum CompanyIntegrationStatus {
  LinkedToImperans = 1,
  NotLinked,
  CompanyDoesNotExistInImperans,
  Integrated,
}
